import BasePaper from '@material-ui/core/Paper'

const Paper = BasePaper

export default Paper
